export const makeSearchParamKey = (formId: string) => `result_${formId}`;

export enum FormResult {
  Error = 'error',
  Success = 'success',
}
